import { createSelector } from 'reselect';
import { getFormValues } from 'redux-form';
import groupBy from 'lodash/groupBy';

import { filterByString } from '@topconagriculture/frontend-utils';

import { RootState } from '../../reducers';
import { ChargeType, CostType } from './costTypes.types';
import { Forms } from '../../form/form.selector';
import { numericStringComapreFunction } from '../../../core/helpers/utils/utils';
import { getLotById } from '../lots/lots.selector';
import { getGroupById } from '../group/group.selector';

export const getCostTypes = (state: RootState): CostType[] => state.entities.costTypes;

export const hasCostTypesSearchFiltersApplied = createSelector(
  [getFormValues(Forms.costTypesSearchForm)],
  (filterForm: any) => typeof filterForm?.search !== undefined,
);

export const getCostTypesListFilteredBySearch = createSelector(
  [getCostTypes, getFormValues(Forms.costTypesSearchForm)],
  (costTypesList, filterForm: any): CostType[] =>
    costTypesList.filter(
      (costType) =>
        filterByString(costType.description, filterForm?.search || '') &&
        (filterForm?.hideNotInUse ? !costType.notInUse : true),
    ),
);

export const getFilteredLotCostTypes = createSelector(getCostTypesListFilteredBySearch, (costs) =>
  costs.filter((cost) => cost.chargeType === ChargeType.LOT),
);

export const getFilteredPenCostTypes = createSelector(getCostTypesListFilteredBySearch, (costs) => {
  return costs.filter((cost) => cost.chargeType === ChargeType.GROUP);
});

export const getCostTypeById = createSelector(
  [getCostTypes],
  (costTypes) => (costTypeId: string) => costTypes.find((costType) => costType.id === costTypeId),
);

export const getGroupedCostTypesInLot = createSelector(
  [getCostTypeById, (state: RootState, id: string) => getLotById(state, id)],
  (getCostType, lot) => {
    const sortedCostsByDescription =
      lot?.additionalCosts
        ?.map((cost) => ({
          ...cost,
          costTypeDescription: getCostType(cost.additionalCostTypeId)?.description || '',
        }))
        .sort((cost1, cost2) => numericStringComapreFunction(cost1.costTypeDescription, cost2.costTypeDescription)) ||
      [];

    return groupBy(sortedCostsByDescription, 'additionalCostTypeId');
  },
);

export const getGroupedCostTypesInPen = createSelector(
  [getCostTypeById, getGroupById],
  (getCostType, getGroup) => (groupdId: string) => {
    const group = getGroup(groupdId);
    const sortedCostsByDescription =
      group?.additionalCosts
        ?.map((cost) => ({
          ...cost,
          costTypeDescription: getCostType(cost.additionalCostTypeId)?.description || '',
        }))
        .sort((cost1, cost2) => numericStringComapreFunction(cost1.costTypeDescription, cost2.costTypeDescription)) ||
      [];

    return groupBy(sortedCostsByDescription, 'additionalCostTypeId');
  },
);
